<div class="dialog_main">
  <button class="dialog_close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'ResetPassword' | translate }}</h2>
      <p>Lorem ipsum dolor set amet</p>
    </div>
    <form [formGroup]="resetPasswordFormGroup" (ngSubmit)="onSubmit()">
      <div class="form_feilds">
        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [type]="hide1 ? 'password' : 'text'"
              class="form_control"
              [placeholder]="'NewPassword' | translate"
              formControlName="newPassword" />
            <span
              mat-icon-button
              matSuffix
              (click)="hide1 = !hide1"
              [attr.aria-mat-label]="'Hide password'"
              [attr.aria-pressed]="hide1"
              class="pass_icon">
              <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
            </span>

            @if (submitted) {
              @if (
                resetPasswordFormGroup.get('newPassword')?.hasError('required')
              ) {
                <mat-error>
                  {{ 'NewPassword' | translate }}
                  {{ 'isRequired' | translate }}
                </mat-error>
              }
              @if (
                !resetPasswordFormGroup.get('newPassword')?.hasError('required')
              ) {
                @for (err of formErrors; track $index) {
                  @if (
                    resetPasswordFormGroup.controls['newPassword'].hasError(
                      err.key
                    )
                  ) {
                    <mat-error>{{ err.message | translate }}</mat-error>
                  }
                }
              }
            }
          </mat-form-field>
        </div>
        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [type]="hide2 ? 'password' : 'text'"
              class="form_control"
              [placeholder]="'ConfirmPassword' | translate"
              formControlName="confirmPassword" />
            <span
              mat-icon-button
              matSuffix
              (click)="hide2 = !hide2"
              [attr.aria-mat-label]="'Hide password'"
              [attr.aria-pressed]="hide2"
              class="pass_icon">
              <mat-icon>{{ hide2 ? 'visibility_off' : 'visibility' }}</mat-icon>
            </span>
          </mat-form-field>
          @if (
            submitted &&
            resetPasswordFormGroup.controls['confirmPassword'].hasError(
              'required'
            )
          ) {
            <mat-error>
              {{ 'confirmPassword' | translate }}
              {{ 'isRequired' | translate }}
            </mat-error>
          }
          @if (
            submitted &&
            resetPasswordFormGroup.controls['confirmPassword'].hasError(
              'mustMatch'
            )
          ) {
            <mat-error>
              {{ 'confirmAndPasswordSame' | translate }}
            </mat-error>
          }
        </div>
      </div>
      <div class="form_btn">
        <button class="btn btn_primary" type="submit">
          {{ 'Continue' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
